import { Box, Stack, useTheme } from "@mui/material";
import type { FormEventHandler, ReactNode } from "react";
import { FormSubmitButton } from "web_myplann/Shared/Components/FormSubmitButton";

type Props = {
	onSubmit: FormEventHandler<HTMLFormElement>;
	submitLabel: string;
	disabled?: boolean;
	loading?: boolean;
	children: ReactNode;
};

export const PortfolioFormShell = ({
	onSubmit,
	submitLabel,
	disabled,
	loading,
	children,
}: Props) => {
	const theme = useTheme();

	return (
		<Stack component="form" onSubmit={onSubmit}>
			{children}

			<Box
				px={theme.spacingTokens.lg}
				pt={theme.spacingTokens.xl}
				pb={theme.spacingTokens.xxl}
			>
				<FormSubmitButton disabled={disabled} loading={loading}>
					{submitLabel}
				</FormSubmitButton>
			</Box>
		</Stack>
	);
};
